import { render, staticRenderFns } from "./vantImage.vue?vue&type=template&id=7aa8d8a6&"
import script from "./vantImage.vue?vue&type=script&lang=js&"
export * from "./vantImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports